<ion-modal>
    <ng-template>
        <ion-content scrollY="false">
            <div class="flex h-full flex-col bg-white text-base" ridangoAppTrapFocus>
                <div class="flex-align-center flex justify-center p-4">
                    <h2 class="text-base font-bold">
                        {{ 'DIALOG_CONFIRM_DELETE_RELATED_CARD_TITLE' | translate }}
                    </h2>
                </div>
                <div class="flex-1 overflow-y-auto p-4">
                    <p>
                        {{ 'DIALOG_CONFIRM_DELETE_RELATED_CARD_DESCRIPTION' | translate }}
                    </p>
                    <div class="mt-4 rounded-lg bg-grey-white_smoke p-4 dark:bg-contrast-black">
                        <ul
                            class="list-disc pl-4"
                            [innerHTML]="'CARD_DELETE_MODAL_LIST_ITEMS_INNER_HTML' | translate"></ul>
                    </div>
                    <p class="mt-4">
                        {{ 'DIALOG_CONFIRM_DELETE_RELATED_CARD_DESCRIPTION_BOTTOM' | translate }}
                    </p>
                </div>
                <div class="p-4">
                    <button
                        class="vl-app-light:bg-[var(--btn-primary-color)] vl-app-light:text-black h-14 w-full rounded-lg bg-secondary font-bold text-white dark:bg-contrast-yellow dark:text-contrast-black"
                        [attr.aria-label]="'DIALOG_CONFIRM_DELETE_BUTTON_OK' | translate"
                        (click)="removeCard()"
                        (keydown.enter)="removeCard()"
                        (keydown.space)="removeCard()">
                        {{ 'DIALOG_CONFIRM_DELETE_BUTTON_OK' | translate }}
                    </button>

                    <button
                        class="vl-app-light:text-primary mt-2 h-14 w-full font-medium text-secondary dark:!text-contrast-yellow dark:text-contrast-yellow"
                        [attr.aria-label]="'DIALOG_BUTTON_CANCEL' | translate"
                        (click)="closeModal()"
                        (keydown.enter)="closeModal()"
                        (keydown.space)="closeModal()"
                        tabindex="0">
                        {{ 'DIALOG_BUTTON_CANCEL' | translate }}
                    </button>
                </div>
            </div>
        </ion-content>
    </ng-template>
</ion-modal>
